<template>
    <div class="col-md-12 justify-content-center mx-auto px-5">
        <table class="mx-auto my-2" style="width:100%;">
            <tbody class="colorabc1">
                <tr>
                    <td style="width:2%;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                        <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                        <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                        <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                        </svg>
                    </td>
                    <td style="width:98%;">
                        <p class="abc-title-main mb-0 pt-1"> {{__("traductionview.clients")}}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <table style="width:100%;">
            <thead>
                <tr>
                    <th class="pr-2" style="padding-bottom:15px!important; width:30%; vertical-align:middle;">
                        <input type="text"
                                style="font-size:11px; width:100%; border:1px solid #3A9AF3; border-radius:5px;"
                                
                                :placeholder="__('traductionview.searchclientname')"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                    </th>
                    <th class="px-2" style="padding-bottom:15px!important; width:30%; vertical-align:middle;">
                        <input type="text"
                                style="font-size:11px; width:100%; border:1px solid #3A9AF3; border-radius:5px;"
                                
                                :placeholder="__('traductionview.searchproject')"
                                v-model="filterproject"
                                @change="onFilterProjectChange()">
                    </th>
                    <th class="px-2" style="padding-bottom:15px!important;  width:30%; vertical-align:middle;">
                        <input type="text"
                                style="font-size:11px; width:100%; border:1px solid #3A9AF3; border-radius:5px;"
                                
                                :placeholder="__('traductionview.searchstaf')"
                                v-model="filterstaff"
                                @change="onFilterStaffChange()">
                    </th>
                    <th class="text-right">
                            <label for="checkbox" class="fts-12 font-weight-bold">{{__("traductionview.hide")}}</label>
                            <input type="checkbox"
                                style="font-size:11px; vertical-align:middle;"
                                id = "checkbox"
                                v-model="filterstatus"
                                @change="onFilterStatusChange()">
                    </th>
                </tr>
            </thead>
        </table>
        <div class="dashboardstyle pt-0">
            <table class="text-center abc-table mx-auto" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom: 1px solid #3A9AF3;">
                        <th class="py-3" style="width:5%; vertical-align:middle;">id</th>
                        <th style="width:30%; vertical-align:middle; text-align:left;">
                            {{__("traductionview.project")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="projectSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="projectSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                           {{__("traductionview.entrepri")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="companySortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="companySortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                            {{__("traductionview.progress")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="statusSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="statusSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:15%; vertical-align:middle;">
                            {{__("traductionview.benif")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="beneficiarySortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="beneficiarySortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:15%; vertical-align:middle;">
                            {{__("traductionview.documentreview")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="todoSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="todoSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="width:15%; vertical-align:middle;">
                            {{__("traductionview.assigned")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="staffSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="staffSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody id="ongoingproject" class="pb-3" style="font-size: 11px; display:block; max-height:450px; overflow:auto; margin-right:2px!important; margin-left:3px!important;">
                    <tr v-for="(customer, index) in customs" :key="index" style="border-bottom:solid rgb(206, 206, 206) 1px;">
                        <td style="vertical-align: middle; width:5%;" class="py-3">
                            <!--<a :href="'/app/manager/project/' + customer.id">-->
                                {{ customer.id }}
                            <!--</a>-->
                        </td>
                        <td style="vertical-align: middle; width:30%; text-align:left; font-weight:bold;">
                            <a :href="'/app/manager/'+country+'/project/' + customer.id" style="color:#3A9AF3!important;" class="triggerspinner">
                                {{ customer.name }}
                            </a>
                        </td>
                        <td style="vertical-align: middle; width:10%; text-transform:capitalize;">
                            {{ customer.client.company }}
                        </td>
                        <td style="vertical-align: middle; width:10%;">
                            {{ Math.round(customer.progress_computed) }} %
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                            {{ customer.user.firstname }} {{ customer.user.lastname }}
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                            {{ customer.documents }}
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                            {{ customer.staff_assigned.firstname }} {{ customer.staff_assigned.lastname }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'customers',
            'country',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                filterproject:"",
                filterstaff:"",
            }
        },

        mounted() {
            this.customers.forEach(customer =>
            {
                this.customs.push(customer)
            });
        },


        methods: {
            onFilterNameChange(){
                this.customs=[];
                this.customers.forEach(customer =>
                {
                    var search = customer.user.firstname.concat(customer.user.lastname).toLowerCase()
                    if (search.includes(this.filtername.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });

            },
             onFilterStaffChange(){
                this.customs=[];
                this.customers.forEach(customer =>
                {
                    var search = customer.staff_assigned.firstname.concat(customer.staff_assigned.lastname).toLowerCase()
                    if (search.includes(this.filterstaff.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });

            },
             onFilterProjectChange(){
                this.customs=[];
                this.customers.forEach(customer =>
                {
                    var search = customer.name.toLowerCase()
                    if (search.includes(this.filterproject.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });

            },
            onFilterStatusChange(){
                this.customs=[];
                if (this.filterstatus)
                {
                    this.customers.forEach(customer =>
                    {
                        if (customer.progress_computed < "100")
                        {
                            this.customs.push(customer);
                        }
                    });

                }
                else
                {
                    this.customers.forEach(customer =>
                    {
                        this.customs.push(customer);
                    })
                }
            },
            projectSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.name < b.name)
                    {
                        return -1;
                    }
                    else if (a.name > b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },

            projectSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.name > b.name)
                    {
                        return -1;
                    }
                    else if (a.name < b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            beneficiarySortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.user.firstname < b.user.firstname)
                    {
                        return -1;
                    }
                    else if (a.user.firstname > b.user.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            beneficiarySortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.user.firstname > b.user.firstname)
                    {
                        return -1;
                    }
                    else if (a.user.firstname < b.user.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            todoSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.documents < b.documents)
                    {
                        return -1;
                    }
                    else if (a.documents > b.documents)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            todoSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.documents > b.documents)
                    {
                        return -1;
                    }
                    else if (a.documents < b.documents)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            statusSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.progress_computed < b.progress_computed)
                    {
                        return -1;
                    }
                    else if (a.progress_computed > b.progress_computed)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            statusSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.progress_computed > b.progress_computed)
                    {
                        return -1;
                    }
                    else if (a.progress_computed < b.progress_computed)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            companySortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.client.company < b.client.company)
                    {
                        return -1;
                    }
                    else if (a.client.company > b.client.company)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            companySortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.client.company > b.client.company)
                    {
                        return -1;
                    }
                    else if (a.client.company < b.client.company)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            staffSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.staff_assigned.firstname < b.staff_assigned.firstname)
                    {
                        return -1;
                    }
                    else if (a.staff_assigned.firstname > b.staff_assigned.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            staffSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.staff_assigned.firstname > b.staff_assigned.firstname)
                    {
                        return -1;
                    }
                    else if (a.staff_assigned.firstname < b.staff_assigned.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
    }
}

</script>